import { type RPPCore } from '@retailer-platform/dashboard/app'
import StoreConfigurationDomain from '@retailer-platform/domain-store-configuration/domainDefinition'
import FulfillmentEventsDomain from '@retailer-platform/domain-fulfillment-events/domainDefinition'
import DraftManagementDomain from '@retailer-platform/domain-draft-management/domainDefinition'
import FeatureEntitlementsManagementDomain from '@retailer-platform/domain-feature-entitlements-management/domainDefinition'
import StorefrontOnboardingDomain from '@retailer-platform/domain-storefront-onboarding/domainDefinition'
import LandingDomain from '@retailer-platform/domain-landing/domainDefinition'
import AccountManagementDomain from '@retailer-platform/domain-account-management/domainDefinition'
import BusinessDomain from '@retailer-platform/domain-business/domainDefinition'
import RecipesAdminDomain from '@retailer-platform/domain-recipes-admin/domainDefinition'
import RecipesV2Domain from '@retailer-platform/domain-recipes-v2/domainDefinition'
import StoreInterventionsDomain from '@retailer-platform/domain-store-interventions/domainDefinition'
import MerchandisingDomain from '@retailer-platform/domain-merchandising/domainDefinition'
import FoodstormDomain from '@retailer-platform/domain-foodstorm/domainDefinition'
import ApprovalsManagementLibraryDomain from '@retailer-platform/domain-approvals-management-library/domainDefinition'
import BannersDomain from '@retailer-platform/domain-banners/domainDefinition'
import WidgetsDomain from '@retailer-platform/domain-widgets/domainDefinition'
import InstacartDeveloperPlatformDomain from '@retailer-platform/domain-instacart-developer-platform/domainDefinition'

export const registerDomains = (app: RPPCore) => {
  app.attachDomain(StoreConfigurationDomain)
  app.attachDomain(FulfillmentEventsDomain)
  app.attachDomain(DraftManagementDomain)
  app.attachDomain(FeatureEntitlementsManagementDomain)
  app.attachDomain(StorefrontOnboardingDomain)
  app.attachDomain(LandingDomain)
  app.attachDomain(AccountManagementDomain)
  app.attachDomain(BusinessDomain)
  app.attachDomain(RecipesAdminDomain)
  app.attachDomain(RecipesV2Domain)
  app.attachDomain(StoreInterventionsDomain)
  app.attachDomain(MerchandisingDomain)
  app.attachDomain(FoodstormDomain)
  app.attachDomain(ApprovalsManagementLibraryDomain)
  app.attachDomain(BannersDomain)
  app.attachDomain(WidgetsDomain)
  app.attachDomain(InstacartDeveloperPlatformDomain)
}
